export const decidirIncertidumbre15 = {
  slug: "decidir-incertidumbre-15",
  title: "Decidir en incertidumbre: pensar sin datos completos",
  durationMin: 15,
  programType: "editorial", // Tipo: editorial | ejecutivo
  
  // Campos de presentación UI
  tagline: "Tomar mejores decisiones cuando no hay certezas.",
  description: "Conversaciones en audio donde dos voces analizan cómo decidir cuando la información es incompleta, sintetizando ideas clave de libros influyentes y llevándolas a criterio práctico.",
  audienceDescription: "Emprendedores · Profesionales · Decisión estratégica",
  sourcesIntro: "Inspirado en 3 bestsellers sobre toma de decisiones",
  
  outcome:
    "Tomar mejores decisiones cuando la información es incompleta.",
  sources: [
    {
      author: "Annie Duke",
      book: "Thinking in Bets",
      institution: "University of Pennsylvania"
    },
    {
      author: "Daniel Kahneman, Olivier Sibony, Cass R. Sunstein",
      book: "Noise",
      institution: "Princeton University"
    },
    {
      author: "Nassim Nicholas Taleb",
      book: "The Black Swan",
      institution: "New York University"
    }
  ],
  units: [
    {
      slug: "u1-pensar-sin-certezas",
      order: 1,
      title: "Pensar sin certezas",
      durationMin: 15,
      preAudioPhrase: "Escucha cómo se razona una decisión cuando la información es incompleta.",
      whyMatters: "Porque nadie decide con información completa, pero muy pocos tienen un sistema para decidir bien con información incompleta. Duke, Kahneman y Taleb demuestran que el problema no es la falta de datos sino la forma en que el cerebro procesa la incertidumbre: confunde ruido con señal, calidad de resultado con calidad de decisión, y predicción con preparación. Corregir esos errores de forma consistente es una ventaja competitiva duradera.",
      objective:
        "Reconocer sesgos cognitivos que distorsionan decisiones en contextos de incertidumbre.",
      audioUrl: "/audio/decidir-incertidumbre-15/u1-pensar-sin-certezas.m4a",
      source: {
        author: "Annie Duke, Daniel Kahneman, Nassim Taleb",
        book: "Thinking in Bets · Noise · The Black Swan"
      },
      bullets: [
        "Las mejores decisiones no garantizan buenos resultados",
        "El ruido cognitivo contamina el juicio más que el sesgo",
        "Prepararse para lo impredecible es más útil que predecir",
      ],
      apply48h:
        "Piensa tu próxima decisión como una apuesta. ¿Qué evidencia tienes? ¿Qué probabilidad asignas a cada escenario?",
      test: {
        questions: [
          "Evalúo mis decisiones por el proceso, no solo por el resultado obtenido.",
          "Soy consciente de cuánto ruido (inconsistencia) hay en mis juicios cotidianos.",
          "Cuando decido, considero explícitamente escenarios improbables pero de alto impacto.",
        ],
        profiles: [
          {
            key: "resultado_obsesivo",
            range: [3, 7],
            label: "Obsesivo por resultados",
            advice: "Separa calidad de decisión de calidad de resultado. Documenta tu razonamiento antes de conocer desenlaces.",
          },
          {
            key: "pensador_probabilistico",
            range: [8, 11],
            label: "Pensador probabilístico",
            advice: "Reduce ruido estandarizando criterios de decisión y usando checklists.",
          },
          {
            key: "estratega_antifragil",
            range: [12, 15],
            label: "Estratega antifrágil",
            advice: "Consolida tu preparación ante cisnes negros: diversifica, reduce fragilidad, capitaliza volatilidad.",
          },
        ],
      },
    },
  ],
};
